require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-in-celebration-of-juneteenth.json") })
        }
      }, "path---blog-in-celebration-of-juneteenth");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-in-celebration-of-juneteenth!./.cache/json/blog-in-celebration-of-juneteenth.json
// module id = 879
// module chunks = 231608221292675